"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderRadiusConfig = void 0;
class BorderRadiusConfig {
    constructor() {
    }
    static getAttributeTypeMap() {
        return BorderRadiusConfig.attributeTypeMap;
    }
}
exports.BorderRadiusConfig = BorderRadiusConfig;
BorderRadiusConfig.discriminator = undefined;
BorderRadiusConfig.attributeTypeMap = [
    {
        "name": "button",
        "baseName": "button",
        "type": "BorderRadiusEnum",
        "format": ""
    },
    {
        "name": "card",
        "baseName": "card",
        "type": "BorderRadiusEnum",
        "format": ""
    },
    {
        "name": "input",
        "baseName": "input",
        "type": "BorderRadiusEnum",
        "format": ""
    }
];
//# sourceMappingURL=BorderRadiusConfig.js.map